'use client';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

import RightIcon from '@/icons/right.svg';

type Props = { scrollTo?: string; disabled: boolean };

function NextLink(props: Props) {
  const { scrollTo, disabled } = props;

  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);

  const page = searchParams.get('page') ?? '1';
  const nextPage = parseInt(page) + 1;

  params.set('page', nextPage.toString());

  // https://www.scottohara.me/blog/2021/05/28/disabled-links.html
  if (disabled) {
    return (
      <a role='link' className='pagination__link' aria-disabled={true}>
        <RightIcon width={24} height={24} />
      </a>
    );
  }

  return (
    <Link
      href={`?${params.toString()}#${scrollTo}`}
      aria-label={`Nächste Seite, Seite ${nextPage}`}
      className='pagination__link'
    >
      <RightIcon width={24} height={24} />
    </Link>
  );
}

export default NextLink;
